import React, { useState } from "react"
import IconPackage from 'xiv-fanfes-2021'
import styled from '@emotion/styled'
import { useLocalization } from "gatsby-theme-i18n";
import LinkItem from "../LinkItem/LinkItem";
import * as breakpoint from '../../styles/breakpoints.module.scss';

const LanguageSwitcher = ({ theme }) => {
  const { currentLocaleObj, config, originalPath,  } = useLocalization();
  const [ dropdownActive, setDropdownActive] = useState(false)

  return(
  <LanguageSwitcherWrapper className={'langSwitcher'}>
    <GlobeIcon theme={theme}>
      <IconPackage.Icon type={'Globe'} />
    </GlobeIcon>
    <DropdownWrapper>
      <Dropdown className={dropdownActive ? 'active' : ''} onClick={(e) => {
          e.preventDefault();
          setDropdownActive(!dropdownActive);
      }}>
        <DropdownCurrent theme={theme} href={'#'} onClick={(e) => {
          e.preventDefault();
          setDropdownActive(!dropdownActive);
      }} title={currentLocaleObj.name}>{currentLocaleObj.localName}</DropdownCurrent>
        <DropdownList>
          {config.map((item,index) => 
            item.name === currentLocaleObj.name ?
              <React.Fragment key={`langOption_${index}`}></React.Fragment>
            :
              <DropdownItem 
                fade 
                to={`/${item.prefix}${originalPath}`}
                value={item.code} key={`langOption_${index}`}
                onClick={() => {
                  setDropdownActive(!dropdownActive);
                }}
                title={item.name}
                >
                {item.name}
              </DropdownItem>
          )}
        </DropdownList>
      </Dropdown>
    </DropdownWrapper>

  </LanguageSwitcherWrapper>)
}

export default LanguageSwitcher;


const LanguageSwitcherWrapper = styled.div`
  display:flex;
  align-items:center;
  position:relative;
  margin-right:8px;

  @media only screen and (max-width: ${breakpoint.headerMax}){
    width:calc(100% - 64px);
    margin:0 32px 64px;
    align-self:flex-end;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:0px;
  }

  @media only screen and (max-width: ${breakpoint.headerMax}) and (max-height: ${breakpoint.headerHeightMax}){
    padding-bottom:104px;
  }
  
`

const GlobeIcon = styled.div`
  color:#FFFFFF;
  font-size:16px;
  width:32px;
  display: flex;
  align-items: center;
  justify-content:center;

  ${props => props.theme === "dark" ? `color:#CACACD;` : `color:#ADADAF;`}

  @media only screen and (max-width: ${breakpoint.headerMax}){
    color:#CACACD;
  }
`

const DropdownWrapper = styled.div`
  width:82px;
  height:56px;
  position:relative;

`

const Dropdown = styled.div`

  position:absolute;
  top:0;
  left:0;
  right:0;
  
  border-radius: 6px;
  transition: .3s all;
  
  &.active{
    background: #FFFFFF;
    box-shadow: 0px 2px 2px -2px rgba(0, 0, 0, 0.05), 0px 6px 6px -6px rgba(0, 0, 0, 0.03), 0px 16px 14px -14px rgba(0, 0, 0, 0.03);

    &:after{
      content:' ';
      display:block;
      position:fixed;
      top:0;left:0;right:0;bottom:0;width:100vw;height:100vh;
    }
  }

  @media only screen and (max-width: ${breakpoint.headerMax}){
    top:auto;
    bottom:0;
    display:flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
  }
  
`

const DropdownCurrent = styled.a`
  height:56px;
  width:100%;
  display:flex;
  align-items:center;
  padding: 14px 16px;
  font-weight:bold;
  font-size: 13px;
  line-height: 16px;
  transition: .3s all;
  text-decoration:none;

  ${props => props.theme === "dark" ? `color:#F2F2F5;` : `color:#4E4E50;`}

  .active &{
    color:#4E4E50 
  }
  

  &:after{
    content:' ';
    display:block;
    position:absolute;
    width:5px;height:5px;
    border:1px solid #FFFFFF;
    border-top:0;
    border-left:0;
    transform: rotate(45deg) translateY(-50%);
    right:24px;
    transition: .3s all;

    ${props => props.theme === "dark" ? `border-color:#F2F2F5;` : `border-color:#4E4E50;`}
    
  }

  .active &:after{
    border-color:#2C2C2E;
    transform: rotate(225deg) translateY(-50%);
  }

  @media only screen and (max-width: ${breakpoint.headerMax}){
    color:#F2F2F5;
    &:after{
      border-color:#F2F2F5;
    }
  }
`
const DropdownList = styled.div`
  height:0;
  position:relative;
  overflow:hidden;
  transition: .3s all;
  z-index:2;
  

  .active &{
    height:136px;
  }
  @media only screen and (max-width: ${breakpoint.headerMax}){
  padding-top: 8px;
  }

`

const DropdownItem = styled(LinkItem)`
  height:32px;
  line-height:32px;
  padding:0 16px;
  font-weight:bold;
  display:block;
  font-size: 13px;
  color: #4E4E50;
  text-decoration:none;

  &:active{
    background:#4E4E50;
    color:#FFFFFF;
  }
  &:hover{
    background:#ECECEF;
  }

`
